/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegionComparison } from '../models/RegionComparison';
import type { UserEngagementList } from '../models/UserEngagementList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserEngagementService {
    /**
     * Get Lineup User Engagement
     * @param areaOfInterestId
     * @param year
     * @param month
     * @returns UserEngagementList Successful Response
     * @throws ApiError
     */
    public static getLineupUserEngagementUserEngagementLineupAreaOfInterestIdYearGet(
        areaOfInterestId: number,
        year: number,
        month?: (number | null),
    ): CancelablePromise<UserEngagementList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user_engagement/lineup/{area_of_interest_id}/{year}',
            path: {
                'area_of_interest_id': areaOfInterestId,
                'year': year,
            },
            query: {
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Event User Engagement
     * @param areaOfInterestId
     * @param year
     * @param month
     * @returns UserEngagementList Successful Response
     * @throws ApiError
     */
    public static getEventUserEngagementUserEngagementEventsAreaOfInterestIdYearGet(
        areaOfInterestId: number,
        year: number,
        month?: (number | null),
    ): CancelablePromise<UserEngagementList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user_engagement/events/{area_of_interest_id}/{year}',
            path: {
                'area_of_interest_id': areaOfInterestId,
                'year': year,
            },
            query: {
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Region Comparison
     * @param limit
     * @param offset
     * @returns RegionComparison Successful Response
     * @throws ApiError
     */
    public static getRegionComparisonUserEngagementRegionComparisonGet(
        limit: number,
        offset: number,
    ): CancelablePromise<RegionComparison> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user_engagement/region_comparison',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
